import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { FaTimes } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';
import Select from 'react-select';

function ModalObterTimes({ setModalObterTime }) {

    const { ListaAreaLinha, LinhaArea, LinhaAtualKey, setEdicaoLinha, ListaLinhaPessoas, ItensLinha, TimeObter } = useContext(ApiContext)

    const [areasSelecionadas, setAreasSelecionadas] = useState([]);


    useEffect(() => {
        ListaAreaLinha()
        ListaLinhaPessoas()
    }, [])

    useEffect(() => {
        if (LinhaArea && LinhaArea.length > 0) {
            const selecionadas = LinhaArea.map((item) => ({
                label: item?.descricao,
                value: item?.key,
            }));
            setAreasSelecionadas(selecionadas);

            const novasAreas = LinhaArea.map((item) => ({
                areaKey: item?.key,
                linhaAtendimentoDemandaKey: LinhaAtualKey,
            }));

            setEdicaoLinha((prev) => ({
                ...prev,
                areas: novasAreas,
            }));
        }
    }, [LinhaArea]);

    return (
        <div className="modal-novo" style={{ zIndex: 9999 }}>
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <div>
                        <h1 className="h1-modal">Time</h1>
                    </div>
                    <div className="btn-close-modal" onClick={() => setModalObterTime(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div className="modal-content">
                    <form className="mb-3">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="geral" title={<span>Geral</span>}>
                                <Row style={{ alignItems: 'center' }}>
                                    <Col xs={10}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Time</Form.Label>
                                            <Form.Control maxLength={100} defaultValue={TimeObter?.nome} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col className='mt-2'>
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" defaultChecked={TimeObter?.ativo} disabled />
                                            <p className='modal-status'>Ativo</p>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Responsável</Form.Label>
                                            <Form.Control maxLength={100} defaultValue={TimeObter?.responsavel.nome} readOnly />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área Solicitante</Form.Label>
                                            <Select
                                                value={areasSelecionadas}
                                                placeholder="Selecione"
                                                isMulti
                                                name="colors"
                                                readOnly
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control maxLength={255} defaultValue={TimeObter?.descricao} readOnly name="descricao" as="textarea" rows={3} />
                                    </Form.Group>
                                </Row>
                            </Tab>
                            <Tab eventKey="pessoas" title={<span>Pessoas</span>}>
                                <Row>
                                    <div className="secao-comentario">
                                        {ItensLinha ?
                                            ItensLinha?.map((item, index) => {
                                                return (
                                                    <div key={index} className="content-comentario">
                                                        <div className="div-comentario" style={{ flexDirection: 'column', alignItems: 'start' }}>
                                                            <p className="p-title" style={{ marginLeft: '5px' }}>Cargo</p>
                                                            <span>{item.cargo.descricao}</span>
                                                        </div>
                                                        <div className="div-comentario" style={{ flexDirection: 'column', alignItems: 'start' }}>
                                                            <p className="p-title" style={{ marginLeft: '5px' }}>Pessoa</p>
                                                            <span>{item.pessoa.nome}</span>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <p>Nã foram adicionados itens a esse time.</p>
                                        }
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>

                    </form>
                </div>
            </div>
        </div>
    )
}

export default ModalObterTimes